// removed by extract-text-webpack-plugin
module.exports = {"xsmall":"only screen and (min-width: 375px)","small":"only screen and (min-width: 481px)","medium":"only screen and (min-width: 768px)","large":"only screen and (min-width: 993px)","xlarge":"only screen and (min-width: 1201px)","footerWrapper":"footerWrapper-3NIeQ","footer":"footer-3BjgK","footerAdBanner":"footerAdBanner-2lq9e","footerContent":"footerContent-37ShN","footerText":"footerText-3zsoT","footerTagline":"footerTagline-ymI09","footerDescription":"footerDescription-15mDn","authLinks":"authLinks-qO65w","accent":"accent-3ZDMd","socialLinks":"socialLinks-PXsUA","confetti":"confetti-1-JDM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/yearInReview/2017/Footer/_footer.css
// module id = 1291
// module chunks = 1